const dev = {
  GO_ENDPOINT: 'https://dev.api.vegetablesale.jp/v1/vegetable',
  SLS_GO_ENDPOINT: 'https://dev.api.vegetablesale.jp/v1/admin/vegetable',
  COGNITO_REGION: 'ap-northeast-1',
  COGNITO_USER_POOL_ID: 'ap-northeast-1_YocqsNAau',
  COGNITO_CLIENT_ID: '7a5t31jst0nkjusdhs01cb5sj7',
};

export {dev};
